import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full bg-gray-50" }
const _hoisted_2 = { class: "max-w-screen-2xl mx-auto px-4 sm:px-6 w-full md:px-8" }
const _hoisted_3 = { class: "flex sticky justify-between bottom-0 flex-col md:flex-row w-full md:items-center border-t-2 border-brand-500" }
const _hoisted_4 = { class: "flex flex-row justify-center md:justify-start w-full mt-2 gap-8" }
const _hoisted_5 = { class: "flex justify-center text-center md:text-left md:justify-end w-full mt-2 md:mr-4 text-xs flex-col md:flex-row sm:space-x-8 sm:py-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex-none" }, [
  /*#__PURE__*/_createElementVNode("p", null, " 〒461-0001 "),
  /*#__PURE__*/_createElementVNode("p", null, " 愛知県名古屋市東区泉1丁目12番25号 "),
  /*#__PURE__*/_createElementVNode("p", null, " シティタワー名古屋久屋大通公園 609号 ")
], -1)
const _hoisted_7 = { class: "flex-none" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, " Tel: 052-962-4778 | Fax: 052-962-4775 ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, " Email: info@crystalwedding.jp ", -1)

import { 
		localesStore
	} from '@/store/locales'

	import { 
		LangTypes
	} from '@/types' // must be imported since file contains an export statement

	import EventBus from '@/events'

	
	// name the component
	const __default__ = { name: "PageFooter" }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	// store
	const store = localesStore()
	const currentYear = new Date().getFullYear()

	function setLanguage(lang: LangTypes) {
		store.locales.selected = lang

		// emit global event to reload data in new language
		EventBus.trigger('change-language', null)
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("footer", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            href: "#",
            class: "link",
            onClick: _cache[0] || (_cache[0] = () => {_ctx.$i18n.locale = 'en'; setLanguage('en')})
          }, " English "),
          _createElementVNode("a", {
            href: "#",
            class: "link",
            onClick: _cache[1] || (_cache[1] = () => {_ctx.$i18n.locale = 'ja'; setLanguage('ja')})
          }, " 日本語 (漢字) "),
          _createElementVNode("a", {
            href: "#",
            class: "link",
            onClick: _cache[2] || (_cache[2] = () => {_ctx.$i18n.locale = 'kana'; setLanguage('kana')})
          }, " 日本語 (仮名) ")
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", null, _toDisplayString(_unref(currentYear)) + " Heartful Inc. ", 1),
            _hoisted_8,
            _hoisted_9
          ])
        ])
      ])
    ])
  ]))
}
}

})